module.exports = __webpack_public_path__ + "static/Enhanced Governance-d6c86c3e0e1568c917bd75ad9339070d.pdf";